import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import Game from "./components/Game";
import RoomForm from "./components/RoomForm";
import Lobby from "./components/Lobby";
import { GameProvider } from "./game/GameProvider";

function App() {
  return (
    <GameProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/game" element={<Game />} />
          <Route path="/join-room" element={<RoomForm mode="join" />} />
          <Route path="/create-room" element={<RoomForm mode="create" />} />
          <Route path="/lobby" element={<Lobby />} />
        </Routes>
      </Router>
    </GameProvider>
  );
}

export default App;
